import React from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import {styled} from "styled-components";
import {Dialog, DialogContent} from "@material-ui/core";

interface PreviewPanelProps {
  onClose: () => void;
  ignoreClickawayRefs: Array<React.RefObject<HTMLElement>>;
}

const FixedPanel = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 10;
  padding: 1em;
  display: flex;

  // width: 100% causes it to overflow the page
  width: -webkit-fill-available;
  width: -moz-available;
`;

export const PreviewPanel = ({
  onClose,
  ignoreClickawayRefs,
  children,
}: React.PropsWithChildren<PreviewPanelProps>) => {
  const [isInteracting, setIsInteracting] = React.useState(false);
  const [isFullscreen, setIsFullscreen] = React.useState(false);
  const childrenRef = React.useRef<HTMLDivElement>(null);

  const handleClickAway = e => {
    const shouldIgnore =
      isInteracting ||
      [...ignoreClickawayRefs, childrenRef].some(
        ref => ref?.current && ref.current.contains(e.target),
      );
    if (shouldIgnore) {
      return;
    }
    onClose();
  };

  const renderedChildren =
    typeof children === "function"
      ? children({setIsInteracting, isFullscreen, setIsFullscreen, onClose})
      : children;

  return (
    <>
      <Dialog fullWidth maxWidth="xl" open={isFullscreen}>
        <DialogContent>{renderedChildren}</DialogContent>
      </Dialog>

      {!isFullscreen && (
        <FixedPanel>
          <ClickAwayListener onClickAway={handleClickAway}>
            <div
              style={{
                display: "flex",
                gap: "0.5em",
                padding: "0.5em 1em",
                flexDirection: "column",
                border: "1px solid #aaa",
                borderRadius: "4px",
                boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
                backgroundColor: "white",
                width: "100%",
                height: "100%",
              }}
            >
              {renderedChildren}
            </div>
          </ClickAwayListener>
        </FixedPanel>
      )}
    </>
  );
};

export const PreviewPanelBody = styled.div`
  max-height: 40vh;
  overflow-y: scroll;
`;

export const PreviewPanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5em;
  border-bottom: 1px solid #ddd;
  background-color: #f9f9f9;
`;
